/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import NodeCollectionEffectBase from './NodeCollectionEffectBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class SetNodeactiveEffect extends NodeCollectionEffectBase
{
    @property
    protected active: boolean = true;

    @property
    protected setOpacity: boolean = false;

    protected trigger: () => void = () =>
    {
        this.reference.WithValue(nodeCollection =>
            {
                nodeCollection.Nodes.forEach(node => this.setActive(node));
            });
    }

    private setActive(node: cc.Node): void
    {
        if (this.setOpacity)
        {
            node.opacity = this.active ? 255 : 0;
            return;
        }

        node.active = this.active;
    }
}
